import Utils from 'core-helpers/utils.js';
import _ from 'underscore';
import PubSub from 'pubsub-js/src/pubsub.js';
import ExceptionService from 'core-services/exceptions/exception-service.js';

/**
 * Private vars
 */
const filename = 'breakpoint-detection.js';
let breakpointIndicator = null;
let currentState = null;

/**
 * Return current breakpoint state
 * @return {Integer}
 * states are:
 *     small:  1
 *     medium: 2
 *     large:  3
 *     above:  4
 * @public
 */
const getState = () => {
    return currentState;
};

/**
 * Return breakpoint state
 * @return {Integer}
 * @private
 */
const getCurrentState = () => {
    if (!breakpointIndicator) {
        ExceptionService.handle('warning', {
            filename,
            message: 'DOM Breakpoint Indicator is not present on current page.',
        });
        return false;
    }

    const index = parseInt(window.getComputedStyle(breakpointIndicator).getPropertyValue('z-index'), 10);
    return index || null;
};

/**
 * Attach a resize event on the window to store the
 * current breakpoint state and fire an event if the state has changed
 * @private
 */
const onResize = () => {
    const newState = getCurrentState();
    if (currentState !== newState) {
        currentState = newState;
        PubSub.publish('BREAKPOINT_DETECTION__CHANGED', currentState);
    }
};

/**
 * Initialization
 * @private
 */
const init = () => {
    /**
     * On load, store the current state
     */
    currentState = getCurrentState();

    // Get breakpoint element
    breakpointIndicator = Utils.getById('breakpoint-indicator');

    /**
     * Listen for window resize events
     */
    window.addEventListener('resize', _.debounce(onResize, 300));
};

init(); // start!

export default {
    getState,
};
